import { createReducer, createAction, createSelector } from '@reduxjs/toolkit'

export const receivePackages = createAction('promos/receive')

export const promoReducer = createReducer(null, (builder) => {
  builder.addCase(receivePackages, (state, action) => {
    return action.payload
  })
})

export const selectPromos = (state) => state.promos

export const selectPromoByCode = createSelector(
  [selectPromos, (state, code) => code],
  (promos, code) => {
    return code && promos?.length
      ? promos?.find(
          (promo) => promo.id && promo.id.toUpperCase() === code.toUpperCase()
        )
      : null
  }
)

export const usePromoExists = createSelector(selectPromos, (promos) => {
  return function (code) {
    return promos?.find(
      (promo) => promo.id && promo.id.toUpperCase() === code.toUpperCase()
    )
  }
})
